var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-tabs', {
    staticClass: "mb-10",
    attrs: {
      "data-permission": "shop_manage_tab",
      "id": "shop_manage_tab",
      "animated": false,
      "activeKey": _vm.activeTab
    },
    on: {
      "change": _vm.handleActiveTaChange
    }
  }, _vm._l(_vm.showTabList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "id": 'shop_manage_tab_' + item.value
      }
    }, [_c('div', {
      attrs: {
        "slot": "tab"
      },
      slot: "tab"
    }, [_c('span', [_vm._v(_vm._s(item.text))])])]);
  }), 1), _c('keep-alive', [_c(_vm.activeTab, {
    ref: "listRef",
    tag: "component",
    attrs: {
      "type": _vm.activeTab
    }
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };